<template>
  <v-container fluid>
    <v-col cols="12">
      <v-card
        class="card"
        color="primary"
      >
        <v-card-text>
          <PreregistrosTable :preregistros="preregistros" />
        </v-card-text>
      </v-card>
    </v-col>
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex';
import PreregistrosTable from '../../components/preregistros/PreregistrosTable.vue';
import getPreregistros from '../../modules/persona/application/getPreregistros';
import createPersonaApiRepository from '../../modules/persona/infrastructure/PersonaApiRepository';

export default {
  components: {
    PreregistrosTable,
  },

  data() {
    return {
      preregistros: [],
    };
  },

  async mounted() {
    this.SET_PERFIL('Antecedentes');
    const repository = createPersonaApiRepository();
    this.preregistros = await getPreregistros(repository);
  },

  methods: {
    ...mapMutations(['SET_PERFIL']),
  },
};
</script>
